// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2LldN","footer":"Form_footer__1H8pr"};